import { Phone, MapPin, Clock } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../../data/content";

export const ContactSidebar = () => (
  <div className="space-y-6">
    <div className="bg-[#121212] border border-zinc-800 rounded-xl p-6 sm:p-8 space-y-5">
      <a href={PHONE_TEL} data-testid="contact-sidebar-call" className="flex items-center gap-4 group">
        <div className="bg-blue-600/10 border border-blue-500/20 rounded-sm p-3">
          <Phone className="h-5 w-5 text-blue-500" />
        </div>
        <div>
          <div className="text-sm text-zinc-500">Call or text anytime</div>
          <div className="font-heading font-bold text-white text-lg group-hover:text-blue-400 transition-colors">{PHONE_DISPLAY}</div>
        </div>
      </a>
      <div className="flex items-center gap-4">
        <div className="bg-blue-600/10 border border-blue-500/20 rounded-sm p-3">
          <Clock className="h-5 w-5 text-blue-500" />
        </div>
        <div>
          <div className="text-sm text-zinc-500">Hours</div>
          <div className="font-heading font-semibold text-white">7 Days a Week · 7 AM – 9 PM</div>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <div className="bg-blue-600/10 border border-blue-500/20 rounded-sm p-3">
          <MapPin className="h-5 w-5 text-blue-500" />
        </div>
        <div>
          <div className="text-sm text-zinc-500">Coverage</div>
          <div className="font-heading font-semibold text-white">Entire Las Vegas Valley</div>
        </div>
      </div>
    </div>

    <div className="rounded-xl overflow-hidden border border-zinc-800" data-testid="contact-map">
      <iframe
        title="Mason's Mobile Mechanic service area — Las Vegas Valley"
        src="https://maps.google.com/maps?q=Las%20Vegas%2C%20NV&t=&z=10&ie=UTF8&iwloc=&output=embed"
        width="100%"
        height="320"
        style={{ border: 0, filter: "invert(90%) hue-rotate(180deg)" }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  </div>
);
